// extracted by mini-css-extract-plugin
export default {"GlitchText":"glitch-text_GlitchText__mx4-7","glitch-text":"glitch-text_glitch-text__E2qmW"};